<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" v-if="allow_edit" />
        <action-button type="delete" @click="del(coursetypegroup.id)" v-if="allow_delete" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12 sm9 lg6>
                <v-text-field
                  name="coursetypegroup.name"
                  v-model="coursetypegroup.name"
                  class="required-field"
                  v-validate="'required|max:150'"
                  :label="$t('coursetypegroups.name')"
                  :error-messages="errors.collect('coursetypegroup.name')"
                  :readonly="!(allow_edit && allow_edit_from_admin)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 sm3 xs12>
                <v-text-field
                  name="coursetypegroup.category"
                  v-model="coursetypegroup.category"
                  class="required-field"
                  v-validate="'required|max:150'"
                  :label="$t('coursetypegroups.category')"
                  :error-messages="errors.collect('coursetypegroup.category')"
                  :readonly="!(allow_edit && allow_edit_from_admin)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 sm6 xs12>
                <v-select
                  name="coursetypegroup.type"
                  v-model="coursetypegroup.type"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="dd_course_type_groups_type"
                  :label="$t('coursetypegroups.type')"
                  :error-messages="errors.collect('coursetypegroup.type')"
                  :readonly="!(allow_edit && allow_edit_from_admin)"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg2 sm6 xs12>
                <v-select
                  name="coursetypegroup.status"
                  v-model="coursetypegroup.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_course_type_groups_status()"
                  :label="$t('coursetypegroups.status')"
                  :error-messages="errors.collect('coursetypegroup.status')"
                  :readonly="!(allow_edit && allow_edit_from_admin)"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox
                  name="coursetypegroup.available_to_all"
                  v-model="coursetypegroup.available_to_all"
                  :label="$t('coursetypegroups.available_to_all')"
                  :error-messages="errors.collect('coursetypegroup.available_to_all')"
                  @change="availableToAllChange"
                >
                </v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox
                  name="coursetypegroup.coursetype_mandatory"
                  v-model="coursetypegroup.coursetype_mandatory"
                  :label="$t('coursetypegroups.coursetype_mandatory')"
                  :error-messages="errors.collect('coursetypegroup.coursetype_mandatory')"
                  :disabled="!Boolean(coursetypegroup.available_to_all)"
                >
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("coursetypes.title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="headers"
                  :items="coursetypes"
                  :items-per-page="coursetypes.length"
                  :options.sync="pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="total"
                  :loading="show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.coursetypegroup_id="{ item }">
                    {{ item.coursetypegroup.name }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    {{ $dd_course_type_groups_status(item.status) }}
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CourseTypeGroupForm",

  props: ["id"],

  data() {
    return {
      allow_edit_from_admin: false,
      allow_edit: false,
      allow_delete: false,
      dd_course_type_groups_type: this.$dd_course_type_groups_type(),

      page_title: "",
      predata: {},
      coursetypegroup: {},

      coursetypes: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
         page: this.$getLocalStorage("__ctgCourseTypeListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      dictionary: {
        attributes: {
          "coursetypegroup.name": this.$t("coursetypegroups.name"),
          "coursetypegroup.category": this.$t("coursetypegroups.category"),
          "coursetypegroup.status": this.$t("coursetypegroups.status"),
          "coursetypegroup.type": this.$t("coursetypegroups.type"),
          "coursetypegroup.available_to_all": this.$t("coursetypegroups.available_to_all"),
          "coursetypegroup.coursetype_mandatory": this.$t("coursetypegroups.coursetype_mandatory")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.coursetypegroup, this.predata, this.save, this.isFormValid)
    })
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh && this.coursetypegroup.id) {
          this.coursetypes_list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__ctgCourseTypeListPage", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("coursetypes.name"), value: "name" },
          { text: this.$t("coursetypes.category"), value: "category" },
          { text: this.$t("coursetypegroups.title"), value: "coursetypegroup_id" },
          { text: this.$t("coursetypes.status"), value: "status" }
        ]
      }
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.coursetypegroup = {}
      this.coursetypegroup = {
        status: this.$getDefaultDropdown(this.$dd_course_type_groups_status())
      }

      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.coursetypegroup))

      this.setReadOnly()
      this.setPageTitle()
    } else {
      this.title = this.$t("coursetypegroups.update_title")

      axios
        .get(this.API_URL + "coursetypegroup/" + this.id)
        .then((res) => {
          this.coursetypegroup = res.data.data

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.coursetypegroup))

          this.setReadOnly()
          this.setPageTitle()
          this.coursetypes_list()
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    setReadOnly() {
      if (this.$hasRole("system-developer")) {
        this.allow_edit = true
        this.allow_edit_from_admin = true
        this.allow_delete = true
        return
      }

      if (_.has(this.coursetypegroup, "id")) {
        this.allow_edit = this.$can("coursetypegroup-edit") && this.coursetypegroup.type !== 0
        this.allow_edit_from_admin = !Number.isInteger(this.coursetypegroup.admin_id)

        this.allow_delete = this.$can("coursetypegroup-delete") && this.coursetypegroup.type !== 0
      } else {
        this.allow_edit = true
        this.allow_edit_from_admin = true
        this.allow_delete = false
      }

      if (this.allow_edit) {
        //this.$delete(this.dd_course_type_groups_type, 0)
      }
    },
    setPageTitle() {
      if (_.has(this.coursetypegroup, "id")) {
        this.page_title = this.$t("coursetypegroups.edit_coursetypegroup", {
          name: this.coursetypegroup.name
        })
      } else {
        this.page_title = this.$t("coursetypegroups.new_coursetypegroup")
      }
    },
    coursetypes_list() {
      this.show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, {
        coursetypegroup_id: this.coursetypegroup.id ? this.coursetypegroup.id : "null"
      })

      axios
        .get(this.API_URL + "coursetypes" + "?" + query)
        .then((res) => {
          this.coursetypes = res.data.data
          this.total = res.data.meta.total
          this.refresh = false
          this.show_loading = false

          this.pagination.page = res.data.meta.current_page
          this.pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.coursetypegroup.id) {
              // Create
              axios
                .post(this.API_URL + "coursetypegroup", {
                  name: this.coursetypegroup.name,
                  category: this.coursetypegroup.category,
                  status: this.coursetypegroup.status,
                  type: this.coursetypegroup.type,
                  available_to_all: this.coursetypegroup.available_to_all,
                  coursetype_mandatory: this.coursetypegroup.coursetype_mandatory
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.coursetypegroup = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.coursetypegroup))

                      vm.setReadOnly()
                      vm.setPageTitle()
                      vm.coursetypes_list()
                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/coursetypegroups/edit/${vm.coursetypegroup.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "coursetypegroup", {
                  id: this.coursetypegroup.id,
                  name: this.coursetypegroup.name,
                  category: this.coursetypegroup.category,
                  status: this.coursetypegroup.status,
                  type: this.coursetypegroup.type,
                  available_to_all: this.coursetypegroup.available_to_all,
                  coursetype_mandatory: this.coursetypegroup.coursetype_mandatory
                })
                .then((res) => {
                  vm.coursetypegroup = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.coursetypegroup))

                  vm.setPageTitle()
                  vm.setPageTitle()
                  vm.coursetypes_list()

                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetypegroup/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/coursetypegroups")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    availableToAllChange() {
      if (!this.coursetypegroup.available_to_all) {
        this.coursetypegroup.coursetype_mandatory = false
      }
    }
  }
}
</script>

<style scoped></style>
